import { useTranslation } from "react-i18next";
import { useDeleteApiAccountFavoritesByFavoriteListIdItemsMutation } from "api/generatedApi";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { useToast } from "shared/toast/hooks/use-toast";
import { useConfirm } from "components/shared/alert/confirm/hooks/use-confirm";

interface Props {
  itemIds: Set<string>;
  listId?: string;
  isOwner: boolean;
}

export function useDeleteFavoriteItems(props: Props) {
  const { itemIds, listId, isOwner } = props;
  const { t } = useTranslation();
  const toast = useToast();
  const canDeleteFavorites = isOwner;
  const [deleteFavoriteList] = useDeleteApiAccountFavoritesByFavoriteListIdItemsMutation();

  const handleOnSuccessClose = () => {
    itemIds.clear();
  };

  const wrapMutation = useMutation({
    onSuccess: handleOnSuccessClose,
    successProps: {
      description: t("account.favorites.itemToastDeleteSuccess"),
    },
    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit = () => {
    wrapMutation(
      deleteFavoriteList({
        favoriteListId: listId ?? "",
        removeFavoritesFromPersonFavoritesListRequest: {
          favoriteIds: Array.from(itemIds),
        },
      })
    );
  };

  const openConfirmDialog = useConfirm({
    title: t("account.favorites.deleteItemTitle"),
    description: t("account.favorites.deleteItemDescription"),
    submitButtonLabel: t("common.delete"),
    submit: handleOnSubmit,
  });

  const handleClick = () => {
    if (!canDeleteFavorites) {
      toast.error(t("account.favorites.cannotDeleteNotOwnerItem"));
      return;
    }
    openConfirmDialog();
  };

  return handleClick;
}
